/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { CompanyService } from './CompanyService';

class CompanyServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new CompanyService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { CompanyServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CompanyServiceProvider.js